import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  ExchangeRateDTO,
  IncomingTaxCodeDTO,
  IncomingTaxCodesService,
  IncomingTaxSystemDTO,
  IncomingTaxSystemsService,
  LookupDTO
} from "../../../core/services/swagger-gen/fordesk";
import { EntityDetailsComponent } from "../../../core/components/abstractions/entity-details.component";
import { FormArray, FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { UnsavedChangesService } from "../../../core/services/helpers/unsaved-changes.service";
import { ActivatedRoute } from "@angular/router";
import { DecimalFormatterService } from "../../../core/helpers/decimal-formatter.service";
import { takeUntil } from "rxjs/operators";
import { ExchangeRateOption } from "../../../core/models/exchange-rate-option";

export interface IncomingInvoiceLinesRelatedFinanceData {
  exchangeRates: ExchangeRateDTO[];
  taxSystemId: number;
  taxCodeId: number;
  disableExchangeRate?: boolean;
  currencies: LookupDTO[];
}

@Component({
  selector: "incoming-invoice-lines-validation-dialog",
  templateUrl: "./incoming-invoice-lines-validation-dialog.component.html",
  styleUrls: ["./incoming-invoice-lines-validation-dialog.component.css"]
})
export class IncomingInvoiceLinesValidationDialogComponent extends EntityDetailsComponent implements OnInit {

  public incomingTaxCodes: IncomingTaxCodeDTO[];
  public incomingTaxSystems: IncomingTaxSystemDTO[];
  public mappedExchangeRates: ExchangeRateOption[];

  constructor(public incomingTaxCodeService: IncomingTaxCodesService,
    public incomingTaxSystemService: IncomingTaxSystemsService,
    private fb: UntypedFormBuilder,
    unsavedChangedService: UnsavedChangesService,
    route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public incomingData: IncomingInvoiceLinesRelatedFinanceData,
    public dialogRef: MatDialogRef<IncomingInvoiceLinesValidationDialogComponent>,
    public formatService: DecimalFormatterService,
    public cdRef: ChangeDetectorRef) {
    super(route, unsavedChangedService);
  }

  public ngOnInit(): void {
    this.resolveLookups();
    this.createForm();
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  protected saveInternal(shouldRedirect?: boolean) {
    const data: IncomingInvoiceLinesRelatedFinanceData = {
      taxCodeId: this.getFormValue("taxCodeId"),
      taxSystemId: this.getFormValue("taxSystemId"),
      exchangeRates: this.getFormValue("exchangeRates"),
      currencies: this.incomingData.currencies//
    };

    this.dialogRef.close(data);
  }

  private createForm(): void {
    this.detailsForm = this.fb.group({
      taxCodeId: [this.incomingData.taxCodeId, [Validators.required]],
      taxSystemId: [this.incomingData.taxSystemId, [Validators.required]]
    });
    //Add exchange rate controls
    this.addExchangeRateControls(this.incomingData.exchangeRates);

    if (this.incomingData.disableExchangeRate) {
      this.f.exchangeRates.disable();
    }

    this.cdRef.detectChanges();
  }

  private resolveLookups(): void {
    this.incomingTaxCodeService.getAllIncomingTaxCodes()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.incomingTaxCodes = response.results.filter(x => !x.isBlocked || x.id == this.incomingData.taxCodeId);
        this.cdRef.detectChanges();
      });

    this.incomingTaxSystemService.getAllIncomingTaxSystems()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.incomingTaxSystems = response.results;
        this.cdRef.detectChanges();
      });
  }

  private addExchangeRateControls(exchangeRates: ExchangeRateDTO[]): void {
    const exchangeRateControls = this.fb.array(exchangeRates
      .map(x => this.fb.group({
        exchangeRate: [x.exchangeRate, Validators.required],
        currencyFromId: [x.currencyFromId, Validators.required],
        currencyToId: [x.currencyToId, Validators.required],
      }))) as FormArray;

    this.mappedExchangeRates = exchangeRateControls.controls.map(group => {
      return {
        control: (group as FormGroup).controls.exchangeRate,
        currencyFrom: this.incomingData.currencies.find(x => x.id == (group as FormGroup).controls.currencyFromId.value),
        currencyTo: this.incomingData.currencies.find(x => x.id == (group as FormGroup).controls.currencyToId.value),
      } as ExchangeRateOption
    });

    this.detailsForm.addControl('exchangeRates', exchangeRateControls)
  }
}
